module.exports = __webpack_public_path__ + "static/media/outdoor_02_B.e698ecdf.png";